import checkbox from "@/presets/lara/checkbox";
import dialog from "@/presets/lara/dialog";
import multiselect from "@/presets/lara/multiselect";

export const dialogPt = {
  ...dialog,
  header: {
    ...dialog.header,
    class: [
      // Flexbox & Alignment
      "flex",
      "justify-between",
      "items-center",
      "shrink-0",
      // Spacing
      "px-6",
      "py-[17.5px]",
      // Colors - Teal background from design
      "!bg-[#D5E9E7]",
      // Border radius
      "rounded-tl-lg",
      "rounded-tr-lg",
    ],
  },
  footer: {
    ...dialog.footer,
    class: [
      // Flexbox & Alignment
      "flex",
      "items-center",
      "justify-end",
      "gap-3",
      "shrink-0",
      // Spacing
      "px-6",
      "py-[17.5px]",
      // Colors
      "!bg-white",
      // Borders
      "border-t",
      "border-t-[#EEF1F4]",
      // Border radius & positioning
      "rounded-bl-lg",
      "rounded-br-lg",
      "sticky",
      "bottom-0",
    ],
  },
};

export const multiSelectPt = {
  ...multiselect,
  root: ({ props, state }) => ({
    class: [...multiselect.root({ props, state }).class, "!border-gray-300"],
  }),
};

export const checkboxPt = {
  ...checkbox,
  box: ({ context, props }) => {
    return {
      class: [...checkbox.box({ context, props }).class, "!w-5 !h-5", "!border-gray-300", "rounded-sm"],
    };
  },
};
